import axios from '@/public/axios';
import { dynamic } from '../router';
import Router from '../router';
import { ref } from 'vue'; // 响应式ref
import { message as Message } from 'ant-design-vue';
import MD5 from 'js-md5';
import Vuex from '@/store';
import html2Canvas from 'html2canvas';
import { JSEncrypt } from 'jsencrypt';
import jsPDF from 'jspdf';
import Vue from 'vue';
import { t } from '@/locales';
const that = new Vue();

// 系统常量
export const prefix = 'pes';
export const tokenName = `${prefix}-token`;
export const rolesName = `${prefix}-roles`;
export const userInfoName = `${prefix}-user-info`;
export const companyInfoName = `${prefix}-companyInfo-name-info`;

// 公共地址
export const publicUrl = "http://pes-dev-2.pesglobe.com";

// 公共文件链接地址
export const filesPublic = `${publicUrl}/bandr/kres_img/`;

// banner使用的链接地址
export const bannerUrl = 'http://222.175.152.42:50176/bandr/';

// iframe地址
export const iframeUrl = "http://222.175.152.42:50133";

// 固定站点
export const station = "pes-dev-2.pesglobe.com";
// export const station = window.location.host;

export const setLC = (name = tokenName, data = {}) => { localStorage.setItem(name, JSON.stringify(data)) };

export const getLC = (name = tokenName) => JSON.parse(localStorage.getItem(name));

export const removeLC = (name = tokenName) => localStorage.removeItem(name);

export const clearLC = () => localStorage.clear();

export const setSC = (name = tokenName, data = {}) => { sessionStorage.setItem(name, JSON.stringify(data)) };

export const getSC = (name = tokenName) => JSON.parse(sessionStorage.getItem(name));

export const removeSC = (name = tokenName) => sessionStorage.removeItem(name);

export const clearSC = () => sessionStorage.clear();

export function setMD5(value) { return MD5(value) };

// JSEncrypt加密
export const setJSEncrypt = (code = "") => {
  let publicKeys = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANL378k3RiZHWx5AfJqdH9xRNBmD9wGD\n' + '2iRe41HdTNF8RUhNnHit5NpMNtGL0NPTSSpPjjI1kJfVorRvaQerUgkCAwEAAQ==';
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(publicKeys);
  const authCode = encrypt.encrypt(code);
  return authCode;
};

export const setUser = async data => {
  let success = false;
  try {
    setLC(userInfoName, data);
    success = true;
  } catch (error) {
    Message.error(error);
  };
  return success;
};

export const getUser = () => {
  let success = false;
  try {
    success = getLC(userInfoName);
  } catch (error) {
    Message.error(error);
  };
  return success;
};

// 公共登录方法
export async function login(data = {}, message = t('common.loginSuccess')) {
  let success = false;
  try {
    const { user, token } = data;
    if (user) setLC(userInfoName, user);
    if (token) setLC(tokenName, token);
    let time = null;
    let res = await new Promise(a => {
      time = setInterval(() => {
        if (!!getUser()) {
          a(!!getUser())
          clearInterval(time);
        }
      }, 200);
    });
    // 用来刷新某些组件，重新获取数据
    // Vuex.commit("setLoginStateKey", Math.random());
    success = res;
    message && Message.success({ content: message, duration: 0.5 });
    dynamic();
  } catch (error) {
    Message.error(error);
  }
  return success;
};

// 公共退出方法
export async function logout(message = t('common.logoutSuccess')) {
  let success = false;
  if (localStorage) {
    try {
      for (let a in localStorage) {
        a.includes(prefix) && removeLC(a);
      };
      message && Message.success({ content: message, duration: 0.5 });
      clearCookie('Authorization');
      Router.$push("/home");
      // 用来刷新某些组件，重新获取数据
      Vuex.commit("setLoginStateKey", Math.random());
      success = true;
      dynamic();
    } catch (error) {
      Message.error(error);
    }
  }
  return success;
};

// 根据当前网页协议申请静态资源访问地址
export const HTP = function (complete = '//222.175.152.42:50139') {
  return `${document.location.protocol}${complete}`;
};

// 自动补全路径前缀
export function autoPrefix(path = '', symbol = '/') { return (path.substring(0, 1) == symbol ? path : (symbol + path)) };

// 禁止调用调试
export function prohibit() {
  try {
    if (process.env.NODE_ENV === 'production') {
      setInterval(() => {
        if (window.outerHeight - window.innerHeight > 200 || window.outerWidth - window.innerWidth > 200) document.body.innerHTML = "检测到非法调试,部分功能已受损,请关闭调试关闭页面,新开页面请求资源!";
        (function () {
          return false;
        }['constructor']('debugger')['call']()
        )
      }, 50);
    }
  } catch (error) {
    console.log(error);
  }
};

// 获取用户权限
export async function getRoles(data = { user: {} }) {
  let user = getUser();
  if (user) data.user = user;
  // 这里的roles是从用户信息中获取发送到后端去获取对应的数组权限
  let roles = check(data, "user.user.roles");
  let url = "api/user_service/roleNew/getMenuCodeById";
  const fn = res => {
    if (res) {
      let { code = 500, entity = [] } = res;
      if (code === 100) {
        setLC(rolesName, entity);
        // 用来刷新某些组件，重新获取数据
        Vuex.commit("setLoginStateKey", Math.random());
      } else {
        Message.error(t('common.rolesSyncFail'))
      }
    }
  };
  if (roles) {
    let rolesString = roles.map(item => item.roleCode).join(",");
    get(`${url}?roleCode=${rolesString}`).then(fn)
  } else {
    get(url).then(fn)
  };
};

// 更新用户信息
export async function updateUser() {
  return new Promise(a => {
    let user = getUser();
    get("open/auth/info?source=PES").then(({ data = null }) => {
      data && setUser({ ...user, ...data });
      a(getUser());
    });
  })
};

// 获取用户当前额度
export async function getUserWordCountBalance() {
  let user = getUser();
  if (user) {
    let form = { unitId: user.user.id, source: "1" };
    let config = { contentType: "1" };
    let { code = 500, data = 0 } = await post("/tran/trans/getUserWordCountBalance", form, config);
    if (code === 200) {
      // setLC("user-limit", data);
      return data;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

// 发起请求前,先判断接口是否需要登录才能使用
export function verify(url = null) {
  let success = false;
  if (url) {
    let urlList = [
      "/api/product_service/std_es/front_list",
      "/api/standard/projectInfo/getCollectAdviceList"
    ];
    // 提示用户登录
    if (urlList.includes(url.split('?')[0])) !getUser() && (success = true);
  };
  return success;
};

// 判断用户是否有权限调用该接口
// export function interfaceManagement(url = null) {
//   let success = false;
//   if (url) {
//     let urlList = [
//       // "manage/favorite",
//       // "manage/favorite/cancel",
//       // "infomation/fileCommon/downloadFile"
//     ];
//     url = url.split('?')[0];
//     if (urlList.includes(url)) {
//       // 提示用户登录
//       // if (!getUser()) {
//       //   success = true;
//       //   LoginTips();
//       // };
//     }
//   };
//   return success;
// };

// 控制并发任务
export const occurSimultaneously = () => {
  class SuperTask {
    constructor(parallelCount = 5) {
      this.parallelCount = parallelCount; // 最大的任务数量
      this.runningCount = 0; // 当前正在执行的任务
      this.tasks = []; // 任务栏
    };

    add(task) {
      return new Promise((resolve, reject) => {
        this.tasks.push({ task, resolve, reject });
        this._run();
      });
    };

    _run() {
      while (this.runningCount < this.parallelCount && this.tasks.length) {
        const { task, resolve, reject } = this.tasks.shift();
        this.runningCount++;
        Promise.resolve(task().then(resolve, reject).finally(() => {
          this.runningCount--;
          this._run();
        }))
      }
    }
  };

  return new SuperTask();
};

// 控制所有请求
let superTask = occurSimultaneously();

// get请求方法
export async function get(url = '', params = {}, config = {}, header = {}) {
  // if (verify(url)) return Promise.resolve({ code: 500, msg: "请登录账号!", msgEn: "Please login account!" });
  if (url != '') {
    let defaultConfig = { method: 'get', contentType: '0', responseType: '', ...config };
    let { method, contentType, responseType, ...rest } = defaultConfig;
    // type 0 对象  1 字符串 2 文件
    switch (contentType) {
      case '0': contentType = 'application/json'; break;
      case '1': contentType = 'application/x-www-form-urlencoded;charset=UTF-8'; break;
      case '2': contentType = 'multipart/form-data; boundary=----WebKitFormBoundary4BV0BjO6QhbqqYQ0'; break;
    };
    let fn = () => {
      return axios({
        method,
        responseType,
        manual: true,
        data: method != 'get' && params,
        params: method == 'get' && removeEmpty(params, (params === 'post' && 'string')),
        url: url.includes('http') ? url : autoPrefix(url, '/'),
        headers: {
          'Content-Type': contentType,
          'Cache-Control': 'no-cache',
          'Signature': 192064719,
          ...header
        },
        ...rest
      }).catch(error => {
        return { code: 500, ...error }
      });
    }
    let res = await superTask.add(fn);
    return res;
  }
};

// put请求方法
export function put(url = '', params = {}, config = {}) {
  if (url != '') {
    let defaultConfig = { method: 'put', contentType: '0', responseType: '', form: false, ...config };
    return get(url, params, defaultConfig);
  }
};

// post请求方法
export function post(url = '', params = {}, config = {}) {
  if (url != '') {
    let defaultConfig = { method: 'post', contentType: '0', responseType: '', form: false, ...config };
    if (defaultConfig.form) {
      let data = new FormData();
      Object.keys(params).forEach(a => data.append(a, params[a]));
      return get(url, data, defaultConfig);
    } else {
      return get(url, params, defaultConfig);
    }
  }
};

// 一个页面要多次取消接口时使用
export function cancells() {
  let controller = null;
  const fn = (url = '', params = {}, config = {}) => {
    if (url != '') {
      let defaultConfig = { method: 'get', contentType: '0', responseType: '', ...config };
      let { method, contentType, ...rest } = defaultConfig;
      // type 0 对象  1 字符串 2 文件
      switch (contentType) {
        case '0': contentType = 'application/json'; break;
        case '1': contentType = 'application/x-www-form-urlencoded;charset=UTF-8'; break;
        case '2': contentType = 'multipart/form-data; boundary=----WebKitFormBoundary4BV0BjO6QhbqqYQ0'; break;
      };
      controller && controller.abort();
      controller = new AbortController();
      return axios({
        method,
        data: method != 'get' && params,
        params: method == 'get' && removeEmpty(params, (params === 'post' && 'string')),
        url: url.includes('http') ? url : autoPrefix(url, '/'),
        headers: { 'Content-Type': contentType },
        signal: controller.signal,
        ...rest
      }).catch(error => {
        // console.log(error);
        // throttles();
      });
    };
  };
  return fn;
};

// download下载方法，自己定义类型文件名称
export function download(url = '', config = {}) {
  if (url != '') {
    let { params = {}, name = `${timestamp({})}.xls`, type = 'xls', responseType = 'blob', ...rest } = config;
    let form = { name, type, responseType, ...rest };
    return get(url, params, form).then(({ data = null }) => {
      if (data) return openFile(data, (typeof params == 'string') ? params : (name.includes('.') ? name : `${name}.${type}`));
    });
  }
};


// iframeDownload下载方法，自己定义类型文件名称
export function iframeDownload(url = '', config = {}) {
  if (url != '') {
    let { params = {}, name = `${timestamp({})}.xls`, type = 'xls', responseType = 'blob', ...rest } = config;
    let form = { name, type, responseType, ...rest };
    return get(url, params, form).then(({ data = null }) => {
      if (data) return pointOpenFile(data, name, type);
    });
  }
};

// downloadDefault下载方法,默认获取后端传递的文件类型与名称
export function downloadDefault(url = '', config = {}) {
  try {
    if (url != '') {
      let { params = {}, responseType = 'blob', json = true, ...rest } = config;
      let form = { responseType, ...rest };
      let fn = (data, headers) => {
        // 从接口的返回头中获取文件的信息
        let fileInformation = headers['content-disposition'];
        if (!fileInformation) return new Promise(a => a({ code: 500, msg: "无法获取文件信息" }));
        let name = fileInformation.split("filename=")[1];
        if (name) {
          let [flieName = null, fileType = 'xls'] = name.split('.');
          return openFile(data, `${flieName}.${fileType}`, json);
        } else {
          return new Promise(a => a({ code: 500, msg: "数据异常" }));
        };
      };
      return get(url, params, form).then(({ data = null, headers = {} }) => { if (data) return fn(data, headers) });
    }
  } catch (error) {
    console.log(error);
  }
};

// 打开二进制文件
export function openFile(file, name, json = false) {
  let success = false;
  if (file) {
    try {
      let link = URL.createObjectURL(new Blob([file]));
      let a = document.createElement('a');
      a.href = link;
      a.download = json ? JSON.parse(name) : name;
      a.click();
      URL.revokeObjectURL(link);
      success = true;
    } catch (error) {
      console.log(error);
    }
  }
  return success;
};


// 打开二进制文件可以带点的
export function pointOpenFile(file, name, type) {
  let success = false;
  if (file) {
    try {
      let link = URL.createObjectURL(new Blob([file]));
      let a = document.createElement('a');
      a.href = link;
      a.download = `${name}.${type}`;
      a.click();
      URL.revokeObjectURL(link);
      success = true;
    } catch (error) {
      console.log(error);
    }
  }
  return success;
};

// 接口数据大于10mb
export async function BIG(url = '', params = {}, config = {}) {
  if (url != '') {
    let defaultConfig = { method: 'post', contentType: '0', responseType: 'blob', form: false, ...config };
    let res = await get(url, params, defaultConfig);
    let fn = () => new Promise(a => {
      const reader = new FileReader();
      reader.readAsText(res);
      reader.onload = event => a(JSON.parse(event.target.result));
    });
    return await fn();
  }
};

// 下载本地static文件
export function derive(url, name = timestamp(), type = 'xls') {
  if (url != '') {
    let path = url.substring(0, 1) == '/' ? url : '/' + url;
    let link = path.includes('.') ? path : (name.includes('.') ? (path + '/' + name) : (path + '/' + name + '.' + type));
    let paths = path.split('/');
    let a = document.createElement('a');
    a.setAttribute('download', paths[paths.length - 1]);
    a.href = link;
    a.click();
    URL.revokeObjectURL(a);
  }
};

// 时间戳
// export function timestamp(string = true) {
//   if (string) return new Date().getTime().toString();
//   return new Date().getTime();
// };

// 即时通讯
export function WS(url = '', fn = () => null) {
  // WebSocket构造函数，创建WebSocket对象
  let ws = new WebSocket(url);
  // readyState 0 正在连接 1 连接成功,可以通讯 2 连接正在关闭 3连接关闭 || 连接失败

  // 向服务器发送消息
  // ws.send('hello')
  // 连接成功后的回调函数
  ws.onopen = function (params) {
    // 客户端连接成功
    fn && fn(1);
  };

  // 从服务器接受到信息时的回调函数
  ws.onmessage = function (e) {
    // 收到服务器响应
    fn && fn(2, e.data);
  };

  // 连接关闭后的回调函数
  ws.onclose = function (evt) {
    // 关闭客户端连接
    fn && fn(3);
  };

  // 连接失败后的回调函数
  ws.onerror = function (evt) {
    // 连接失败了
    fn && fn(0);
  };

  let send = async a => {
    let success = false;
    if (ws.readyState === 1) {
      ws.send(a);
      success = true;
    } else {
      that.$message.error('连接还未建立成功!');
    };
    return success;
  };

  let close = () => ws.close();

  return { ws, send, close };
};

// 移除空值对象
export function removeEmpty(object = {}, type) {
  if (Object.keys(object).length > 0) {
    let data = {};
    for (let a in object) {
      if (object[a] != ''
        && !a.includes('$')
        && object[a] != null
        && object[a] != undefined
        && object[a] != 'undefined'
      ) {
        data[a] = object[a];
      };
      // 数字0需要不能被过滤
      if (object[a] === 0) data[a] = object[a];
    };
    if (type === 'string') {
      let string = '';
      Object.keys(data).forEach(key => string += `${key}=${data[key]}&`);
      data = string;
    };
    return data;
  }
};

// 获取cookie
export const getCookie = function (name) {
  let nameEQ = name + '='
  let ca = document.cookie.split(';') // 把cookie分割成组
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i] // 取得字符串
    while (c.charAt(0) == ' ') { // 判断一下字符串有没有前导空格
      c = c.substring(1, c.length) // 有的话，从第二位开始取
    }
    if (c.indexOf(nameEQ) == 0) { // 如果含有我们要的name
      return unescape(c.substring(nameEQ.length, c.length)) // 解码并截取我们要值
    }
  }
  return false
};

// 设置cookie
export const setCookie = function (name = null, value = null, seconds = 100) {
  let expires = "";
  if (seconds != 0) {      //设置cookie生存时间
    let date = new Date();
    date.setTime(date.getTime() + (seconds * 1000));
    expires = "; expires=" + date.toGMTString();
  }
  document.cookie = name + "=" + escape(value) + expires + "; path=/";   //转码并赋值
};

// 清除cookie
export const clearCookie = function (name) { setCookie(name, "", -1) };


// 格式化时间戳 为日期字符串
export function formatTime(timestamp = null, format = 'YYYY-MM-DD H:M:S') {
  if ((timestamp && timestamp.toString().length == 10) || (timestamp && timestamp.toString().length == 13)) {
    const time = new Date(timestamp.toString().length == 10 ? (timestamp * 1000) : timestamp); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const YYYY = time.getFullYear();
    const MMMM = ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1));
    const DDDD = (time.getDate() < 10 ? '0' + time.getDate() : time.getDate());
    const H = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
    const M = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
    const S = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();
    const week = () => {
      switch (time.getDay()) {
        case 1: return '周一';
        case 2: return '周二';
        case 3: return '周三';
        case 4: return '周四';
        case 5: return '周五';
        case 6: return '周六';
        default: return '周日';
      }
    };
    if (format) {
      switch (format.toUpperCase()) {
        case 'YYYY年MM月DD日 H时M分S秒': return YYYY + '年' + MMMM + '月' + DDDD + '日' + ' ' + H + '时' + M + '分' + S + '秒';
        case 'YYYY年MM月DD日 H:M:S': return YYYY + '年' + MMMM + '月' + DDDD + '日' + ' ' + H + ':' + M + ':' + S;
        case 'YYYY年MM月DD日 H时M分': return YYYY + '年' + MMMM + '月' + DDDD + '日' + ' ' + H + '时' + M + '分';
        case 'YYYY年MM月DD日 H:M': return YYYY + '年' + MMMM + '月' + DDDD + '日' + ' ' + H + ':' + M;
        case 'YYYY年MM月DD日': return YYYY + '年' + MMMM + '月' + DDDD + '日';
        case 'YYYY-MM-DD H时M分S秒': return YYYY + '-' + MMMM + '-' + DDDD + ' ' + H + '时' + M + '分' + S + '秒';
        case 'YYYY-MM-DD H:M:S': return YYYY + '-' + MMMM + '-' + DDDD + ' ' + H + ':' + M + ':' + S;
        case 'YYYY-MM-DD H时M分': return YYYY + '-' + MMMM + '-' + DDDD + ' ' + H + '时' + M + '分';
        case 'YYYY-MM-DD H:M': return YYYY + '-' + MMMM + '-' + DDDD + ' ' + H + ':' + M;
        case 'YYYY-MM-DD': return YYYY + '-' + MMMM + '-' + DDDD;
        case 'YYYY/MM/DD H时M分S秒': return YYYY + '/' + MMMM + '/' + DDDD + ' ' + H + '时' + M + '分' + S + '秒';
        case 'YYYY/MM/DD H:M:S': return YYYY + '/' + MMMM + '/' + DDDD + ' ' + H + ':' + M + ':' + S;
        case 'YYYY/MM/DD H时M分': return YYYY + '/' + MMMM + '/' + DDDD + ' ' + H + '时' + M + '分';
        case 'YYYY/MM/DD H:M': return YYYY + '/' + MMMM + '/' + DDDD + ' ' + H + ':' + M;
        case 'YYYY/MM/DD': return YYYY + '/' + MMMM + '/' + DDDD;
        case 'YYYY.MM.DD H时M分S秒': return YYYY + '.' + MMMM + '.' + DDDD + ' ' + H + '时' + M + '分' + S + '秒';
        case 'YYYY.MM.DD H:M:S': return YYYY + '.' + MMMM + '.' + DDDD + ' ' + H + ':' + M + ':' + S;
        case 'YYYY.MM.DD H时M分': return YYYY + '.' + MMMM + '.' + DDDD + ' ' + H + '时' + M + '分';
        case 'YYYY.MM.DD H:M': return YYYY + '.' + MMMM + '.' + DDDD + ' ' + H + ':' + M;
        case 'YYYY.MM.DD': return YYYY + '.' + MMMM + '.' + DDDD;
        case 'YYYY年MM月DD日 D': return YYYY + '年' + MMMM + '月' + DDDD + '日' + ' ' + week();
        case 'YYYY-MM-DD D': return YYYY + '-' + MMMM + '-' + DDDD + ' ' + week();
        case 'YYYY/MM/DD D': return YYYY + '/' + MMMM + '/' + DDDD + ' ' + week();
        case 'YYYY.MM.DD D': return YYYY + '.' + MMMM + '.' + DDDD + ' ' + week();
        default: return YYYY + '-' + MMMM + '-' + DDDD + ' ' + H + ':' + M + ':' + S + ' ' + week();
      }
    }
    return YYYY + '-' + MMMM + '-' + DDDD + ' ' + H + ':' + M + ':' + S + ' ' + week();
  }
};

// 获取往前的时间戳
export const timestamp = function ({ day = 7, mode = "timestamp", format = "YYYY-MM-DD", contain = true }) {
  // contain 是否包含今天
  contain && day && (day = day - 1);
  let timestamp = new Date(new Date(new Date().toLocaleDateString()).getTime() - day * 24 * 3600 * 1000).getTime() / 1000;
  switch (mode) {
    case 'timestamp': return timestamp;
    case 'date': return formatTime(timestamp, format);
  }
};

// 深度拷贝
export const deepCopy = value => JSON.parse(JSON.stringify(value));

// 完整拷贝
export const deepClone = function (source, cache) {
  if (!cache) {
    cache = new Map()
  }
  if (source instanceof Object) { // 不考虑跨 iframe
    if (cache.get(source)) { return cache.get(source) }
    let result
    if (source instanceof Function) {
      if (source.prototype) { // 有 prototype 就是普通函数
        result = function () { return source.apply(this, arguments) }
      } else {
        result = (...args) => { return source.call(undefined, ...args) }
      }
    } else if (source instanceof Array) {
      result = []
    } else if (source instanceof Date) {
      result = new Date(source - 0)
    } else if (source instanceof RegExp) {
      result = new RegExp(source.source, source.flags)
    } else {
      result = {}
    }
    cache.set(source, result)
    for (let key in source) {
      if (source.hasOwnProperty(key)) {
        result[key] = deepClone(source[key], cache)
      }
    }
    return result
  } else {
    return source
  }
};


// export const deepCopyObject = function (data) {
//   if (data instanceof Date) {
//     return new Date(data.valueOf());
//   } else if (data instanceof Array) {
//     var arr = [];
//     data.forEach(value => {
//       arr.push(dC(value));
//     })
//     return arr;
//   } else if (typeof data === "object" && data !== null) {
//     var obj = {};
//     for (let key in data) {
//       obj[key] = dC(data[key]);
//     }
//     return obj;
//   } else {
//     return data;
//   }
// };

// 设置文字大小适配屏幕
export const setFontSize = function (num = 1) { return { fontSize: `${this.$store.state.fontSize * num}px` } };

// 配合echarts计算文字大小
export const getFontSize = (ref, value = null) => {
  if (!ref) return;
  let { offsetWidth, offsetHeight } = ref;
  if (value) {
    switch (value) {
      case 'width': return offsetWidth / 100;
      case 'height': return offsetHeight / 100;
    }
  } else {
    let minValue = offsetWidth <= offsetHeight ? offsetWidth : offsetHeight;
    let titleFontSize = minValue / 100;
    return titleFontSize;
  }
};

// 防抖函数
export function debounce(fn, delay = 1000) {
  let debounceTimes = null;
  let event = data => {
    clearTimeout(debounceTimes);
    debounceTimes = null;
    debounceTimes = setTimeout(() => fn(data), delay);
  };
  return event;
};

// 节流函数
export function throttle(fn, delay = 1000) {
  let throttleTimes = null;
  function timeout() {
    throttleTimes = setTimeout(() => {
      clearTimeout(throttleTimes);
      throttleTimes = null;
    }, delay)
  };
  let event = (...rest) => {
    if (throttleTimes) return;
    fn(...rest);
    timeout();
  };
  return event;
};

//maxFrameCount 当前数组长度
//render 从数组第多少条开始渲染 一般与stopNum配合使用，他俩值最好相同
//open 是否从零开始渲染open
//end 帧动画结束时的回调
export function useDefer({ maxFrameCount = 0, render = 0, open = true, end = () => null }) {
  const frameCount = ref(open || (maxFrameCount - render));
  const refreshFrameCount = () => {
    requestAnimationFrame(() => {
      frameCount.value++;
      if (frameCount.value < maxFrameCount) refreshFrameCount();
      if (frameCount.value === (maxFrameCount - 1)) end();
    });
  };
  refreshFrameCount();
  return function (showInframeCount) { return frameCount.value >= showInframeCount };
};

// 形参b为遍历索引，b小于stopNum就不走动画帧渲染 / 一般stopNum 与 render 要相同
export function showDom({ stopNum = 0, b, deferKey = "defer" }) {
  return (b < stopNum) || (this[deferKey] && this[deferKey](b))
};

// 纯粹帧动画
export function useDeferPurity({ maxFrameCount = 0 }) {
  const frameCount = ref(maxFrameCount || 0);
  const refreshFrameCount = () => {
    requestAnimationFrame(() => {
      frameCount.value++;
      if (frameCount.value < maxFrameCount) refreshFrameCount();
    });
  };
  refreshFrameCount();
  return function (showInframeCount) { return frameCount.value >= showInframeCount };
};

// 形参b为遍历索引，b小于stopNum就不走动画帧渲染 / 一般stopNum 与 render 要相同
export function showDomPurity({ b = 0, defer = null }) {
  return (defer && defer(b))
};

// 将表格需要的数据处理出来
export function sheets(a, b) {
  let key = b['prop'];
  let keyIndex = `${key.slice(0, 1)}${a['!index']}`; //用于修改原始数据时的索引
  let value = a[key];
  return {
    key,
    keyIndex,
    value
  }
};

// 判断数据类型
export const dataType = function (value) {
  try {
    return Object.prototype.toString.call(value).split(" ")[1].replace(']', '');
  } catch (error) {
    Message.error(error)
  }
};

// 计算数组的列数
export const getColumn = (arrLength, rowsLength) => Math.floor(arrLength / rowsLength) + (arrLength % rowsLength ? 1 : 0);

// 获取对应的语言
export const getLanguage = value => {
  try {
    if (typeof value === "string") {
      let list = value.split('/');
      let data = Language;
      list.map(a => data = data[a]);
      const lang = Vuex.state.language;
      const current = data && data[lang];
      if (current != null && String(current).trim() !== '') return current;
      return (data && (data.chinese || data.english)) || '';
    } else {
      const lang = Vuex.state.language;
      const current = value && value[lang];
      // 英文版若未配置 english/remark，回退中文，避免单选/下拉标签空白
      if (current != null && String(current).trim() !== '') return current;
      return (value && (value.chinese || value.english)) || '';
    }
  } catch (error) {
    Message.error(error)
  }
};

// 获取通用接口数据
export const getDictionary = async function (key, time = 100, accumulation = 400) {
  let res = await new Promise(a => {
    let times = null;
    let observe = () => {
      times = setTimeout(() => {
        if (!this.$DC[key]) {
          time += accumulation;
          observe();
        } else {
          clearTimeout(times);
          times = null;
          return a(this.$DC[key]);
        };
      }, time);
    };
    observe();
  });
  return res;
};

// 登录弹窗操作
export const visibleLogin = async function (value = 0) {
  let success = false;
  try {
    // 0 隐藏登录窗口 1显示账号登录窗口 2显示手机号登录窗口 3显示注册窗口
    switch (value) {
      case 0: Vuex.commit('setVisibleLogin', false); break; //隐藏登录窗口
      case 1:
        Vuex.commit('setLoginStatus', true);
        Vuex.commit('setLoginSelect', '0');
        Vuex.commit('setVisibleLogin', true);
        break; //显示账号登录窗口
      case 2:
        Vuex.commit('setLoginStatus', true);
        Vuex.commit('setLoginSelect', '1');
        Vuex.commit('setVisibleLogin', true);
        break; //显示手机号登录窗口
      case 3:
        Vuex.commit('setLoginStatus', false);
        Vuex.commit('setVisibleLogin', true);
        break; //显示注册窗口
    };
    success = true;
  } catch (error) {
    console.log(error);
  };
  return success;
};

// 提示
export const Tips = function (fn = () => null, config = {}) {
  let {
    title = t('common.tip'),
    content = t('common.notLoggedIn'),
    okText = t('common.confirm'),
    cancelText = t('common.cancel'),
    type = 'warning',
    centered = true
  } = config;
  // !Vuex.state.visibleLogin 显示登录窗口时,不显示该弹窗
  !Vuex.state.visibleLogin && that.$confirm({
    title, content, okText, cancelText, type, centered,
    onOk(onFn) {
      onFn();
      fn && fn({ success: true });
    },
    onCancel(onFn) {
      onFn();
      fn && fn({ success: false })
    }
  });
};

// 提示登录 index 0 隐藏登录窗口 1显示账号登录窗口 2显示手机号登录窗口 3显示注册窗口
export const LoginTips = function (config = {}, index = 1) { Tips(({ success }) => { if (success) visibleLogin(index) }, config) };

// 判断元素是否可见
export function elVisible(fn = () => null, config = {}) {
  // visible = true 元素不可见时也返回事件,否则我只需要元素可见时触发
  // threshold = 0 监听元素出现交叉就触发 / = 1 元素必须完全出现才触发 / = 0.5 元素出现一半就触发
  // rootMargin 扩张 向内或向外扩张交叉区域
  let { visible = false, ...rest } = config;
  let configs = { threshold: 0, rootMargin: "-50%", ...rest };
  const observe = entries => {
    for (const { isIntersecting = false, target = {} } of entries) {
      // created && created(target);
      if (visible) {
        fn && fn(target, isIntersecting)
      } else {
        isIntersecting && fn && fn(target, isIntersecting, subsidiary)
      };
    };
  };
  let subsidiary = new IntersectionObserver(observe, configs);
  const carryOut = refs => {
    let fn = item => subsidiary.observe(item.$el || item);
    let arrFn = () => refs && refs.map(item => subsidiary.observe(item.$el || item));
    switch (dataType(refs)) {
      case "HTMLImageElement": fn(refs); break; // 监听一个dom
      case "HTMLDivElement": fn(refs); break; // 监听一个dom
      case "Array": arrFn(refs); break; // 监听多个dom
      default: return false;
    };
  };
  return carryOut;
};

// 让元素到达指定位置
export function Scroll(dom = '', config = {}) {
  let configs = { behavior: "smooth", block: "start", ...config };
  dom && dom.scrollIntoView && dom.scrollIntoView(configs);
};

// 将当前语言模式转为布尔值
// export function CE() {
//   let { language = 'chinese' } = Vuex.state;
//   switch (language) {
//     case 'english': return 0;
//     case 'chinese': return 1;
//   }
// };

// copy事件
export function Copy(dom = {}, value = '') {
  let input = dom;
  document.body.appendChild(input);
  input.innerHTML = value;
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);
  that.$message.success(t('common.copySuccess'));
};

// 对用户权限进行判断,仅有是否显示
export function limitsVisible(list, key = 'every') {
  let value = false;
  let roles = getLC(rolesName);
  if (roles) {
    let arr = list.map(item => {
      let obj = roles.find(a => a == item);
      if (obj) return true;
    });
    // every 所有权限都必须满足  some 只需要满足一个权限即可
    value = arr[key](a => a);
  }
  return value;
};

// 对用户权限进行判断,并提示
export async function limitsTips(config = { list: [], key: "every", content: null, tips: true }) {
  let { list = [], key = "every", content = null, tips = true } = config;
  let value = false;
  let roles = getLC(rolesName);
  if (roles) {
    let arr = list.map(item => {
      let obj = roles.find(a => a == item);
      if (obj) return true;
    });
    // every 所有权限都必须满足  some 只需要满足一个权限即可
    value = arr[key](a => a);
  };
  if (!value && tips) {
    // 如果用户没有登录先让其登录
    if (!getUser()) {
      content = t('common.notLoggedIn')
      LoginTips({ content });
    } else {
      !content && (content = t('common.noPermission'));
      // LoginTips({ content });
      Tips(false, { content });
    };
  };
  return value;
};

// 对用户权限进行判断,过滤掉不匹配的数据
export function filterLimitsVisible(config) {
  let { data = [], key = "every" } = config;
  return data.filter(({ rolesKey = null }) => rolesKey ? limitsVisible(rolesKey.split(','), key) : true);
};

// 获取网页对象
export function getBody(key = 'clientWidth') {
  let body = document.body;
  return key ? body[key] : body;
};

// 解压压缩包
export async function decompressFiles(file = {}) {
  const zip = new JSZip(); // 创建实例
  const zipFile = await zip.loadAsync(file, { decodeFileName: function (bytes) { return iconv.decode(bytes, 'gbk') } }); // 获取zip压缩包
  let { files = [] } = zipFile;
  let arr = [];
  for (const item in files) {
    let { dir = true, name = '', date = '', unsafeOriginalName = '' } = files[item];
    if (!dir) {
      const file1 = zipFile.file(item); // 获取需要解压的文件
      const content = await file1.async('blob'); // 获取文件二进制流
      let compressName = name.split('/').pop(); // 拿到二进制流文件名称
      content.name = compressName;
      content.unsafeOriginalName = unsafeOriginalName;
      content.date = date;
      // 将二进制流文件放到文件中
      let filess = new File([content], compressName);
      filess.url = unsafeOriginalName;
      arr.push(filess);
    };
  };
  return arr;
};

// 对图片进行压缩
export function compressImg(File = {}, quality = 0.5) {
  return new Promise(a => {
    // 对图片进行压缩
    const compress = (baseUrl = "") => {
      // 创建canvas
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext("2d");
      // 获取图片宽高
      const img = new Image();
      img.src = baseUrl;
      img.onload = () => {
        let { width, height } = img;
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        const newBase64 = canvas.toDataURL(File.type, quality);
        a(newBase64);
      }
    };
    // 将图片转为base64格式
    const createdBase64 = () => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(File);
      fileReader.onload = ({ target = {} }) => compress(target.result);
    };
    createdBase64();
  });
};

// 将html导出为pdf
// export const derivePdf = (dom = null, title = '', config = { background: '#fff', useCORS: true, scrollY: true, x: 0, y: 0 }) => {
//   if (!dom) return Message.error("请传入dom!");
//   return new Promise(a => {
//     html2Canvas(dom, config).then(canvas => {
//       let contentWidth = canvas.width;
//       let contentHeight = canvas.height;
//       let pageHeight = (contentWidth / 592.28) * 841.89;
//       let leftHeight = contentHeight;
//       let position = 0;
//       let imgWidth = 595.28
//       let imgHeight = (595.28 / contentWidth) * contentHeight
//       let pageData = canvas.toDataURL('image/jpeg', 1.0)
//       let pdf = new jsPDF('', 'pt', 'a4');
//       if (leftHeight < pageHeight) {
//         pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
//       } else {
//         // 分页
//         while (leftHeight > 0) {
//           pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
//           leftHeight -= pageHeight
//           position -= 841.89
//           // 避免添加空白页
//           if (leftHeight > 0) pdf.addPage();
//         }
//       };
//       pdf.save(`${title}`);
//       a(true);
//     });
//   });
// };

// 将html导出为pdf带有上下边距
export const derivePdf = (dom = null, title = '', config = {}) => {
  if (!dom) return Message.error("请传入dom!");
  return new Promise(a => {
    //创绘制切割后绘制canvas用的canvas标签以及对应的context对象
    const perCanvas = document.createElement('canvas');
    perCanvas.style.backgroundColor = '#fff'
    const context = perCanvas.getContext('2d');
    let { background = '#fff', useCORS = true, scrollY = true, paddingHeight = 100, ...rest } = config;

    // 将需要下载的html标签转成canvas标签，并获取对应的base64码
    html2Canvas(dom, { background, useCORS, scrollY, ...rest }).then(canvas => {
      const canvasData = canvas.toDataURL('image/jpeg', 1.0);

      // pdf的尺寸
      const pdfWidth = canvas.width;
      const pdfHeight = pdfWidth * 1.414;

      //切割后的canvas图片的宽高，就等于每页pdf的宽高
      perCanvas.width = canvas.width;
      perCanvas.height = pdfHeight;

      // 每张图片的高度：适当减少100，上下各留50页边距
      const perHeight = pdfHeight - paddingHeight;

      // 计算切割次数
      let splitCount = Math.ceil(canvas.height / perHeight);
      if (splitCount * perHeight < canvas.height) splitCount++;

      //创建img对象，加载完整的canvas图片
      const img = new Image();
      img.src = canvasData;

      //创建pdf对象
      const pdf = new jsPDF('p', 'pt', [pdfWidth, pdfHeight]);
      //待图片加载完成
      let time = null;
      time = setTimeout(() => {
        //切割canvas图片，贴到每一页pdf中
        for (let i = 0; i < splitCount; i++) {
          const startY = i * perHeight; // 起始y坐标

          // 清空画布
          context.clearRect(0, 0, perCanvas.width, pdfHeight);
          context.fillStyle = '#fff';
          context.fillRect(0, 0, perCanvas.width, pdfHeight);
          // 绘制当前切割区域的图片
          context.drawImage(img, 0, startY, perCanvas.width, perHeight, 0, 0, perCanvas.width, perHeight);
          const perCanvasData = perCanvas.toDataURL('image/jpeg', 1.0);
          pdf.addImage(perCanvasData, 'JPEG', 0, 50, perCanvas.width, perCanvas.height);
          if (i < splitCount - 1) pdf.addPage();
        };
        pdf.save(`${title}`);
        clearTimeout(time);
        time = null;
        a(true);
      }, 5000);
    })
  });
};

// 数组去重
export const removeDuplicate = (arr = []) => {
  let len = arr.length
  for (let i = 0; i < len; i++) {
    for (let j = i + 1; j < len; j++) {
      if (arr[i] === arr[j]) {
        arr.splice(j, 1)
        len-- // 减少循环次数提高性能
        j-- // 保证j的值自加后不变
      }
    }
  }
  return arr;
};

// 获取对象中的某些属性时,判断一下，避免出现空指针
export const check = (data = {}, key = null, message = null) => {
  if (!data || !key) return message;
  let list = key.split(".");
  for (let i = 0; i < list.length; i++) {
    let value = data[list[i]];
    if (!value) return message;
    data = value;
    if ((i + 1) === list.length) return value;
  };
};

// 给数据添加排序索引
export const addSortIndex = ({ page = 1, pageSize = 10, list = [] }) => {
  let number = (page - 1) * pageSize;
  return list.map((item, index) => {
    item.sortIndex = number + index + 1;
    return item;
  });
};